export default class CalculateBudgetingPlannerPMRecord {

    /**
     *
     * @param plannerPM {BudgetingPlannerPM}
     */
    async calculatePlannerWithProduct(plannerPM) {
        // TODO powtórzona logika w widoku -> ProductInSeasonView
        if (plannerPM.productId != null) {
            plannerPM.sellingValue = plannerPM.netPrice?.decimal?.multiply(plannerPM.quantityPOS) ?? null;
            plannerPM.purchaseValue = plannerPM.price?.decimal?.multiply(plannerPM.quantityPOS) ?? null;
            plannerPM.sellingValueOnline = plannerPM.netPrice?.decimal?.multiply(plannerPM.onlineQuantity) ?? null;
            plannerPM.onlinePurchaseValue = plannerPM.price?.decimal?.multiply(plannerPM.onlineQuantity) ?? null;

            // plannerPM.totalQuantity = plannerPM.quantityPOS + plannerPM.onlineQuantity;
            let quantityOuter = plannerPM.productIdProductIdQuantityOuter;
            let totalQuantity = plannerPM.totalQuantity;
            if (quantityOuter !== 0 && quantityOuter && totalQuantity) {
                let numberOfOuters = new BigDecimal(totalQuantity).divide(new BigDecimal(quantityOuter));
                let numberOfOutersRounded = Math.round(100 * numberOfOuters) / 100;
                plannerPM.numberOfOuters = new BigDecimal(numberOfOutersRounded);
                let fractionalPart = plannerPM.numberOfOuters.subtract(new BigDecimal(Math.floor(plannerPM.numberOfOuters)));
                if (fractionalPart.compareTo(BigDecimal.ZERO) === 1) {
                    plannerPM.__cellClasses = {numberOfOuters: "bg-danger"};
                }
            }

            plannerPM.sellingValueTotal = plannerPM.netPrice?.decimal?.multiply(plannerPM.totalQuantity) ?? null;
            plannerPM.purchaseValueTotal = plannerPM.price?.decimal?.multiply(plannerPM.totalQuantity) ?? null;
        }
    }

}